import React from "react";

export const handleKeyPress = (
  event: React.KeyboardEvent<HTMLInputElement>,
) => {
  const regex = /^[a-zA-Z0-9\s]*$/; // Permite apenas letras, números e espaços
  if (!regex.test(event.key)) {
    event.preventDefault();
  }
};
